var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUntilShipped(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.499878,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    fill: "white",
    stroke: "#C3C5D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0012 23.7207C21.0012 23.2903 21.2766 22.9082 21.685 22.7721L29.6842 20.1054C29.8894 20.037 30.1113 20.037 30.3166 20.1054L38.3174 22.7721C38.7258 22.9082 39.0012 23.2903 39.0012 23.7208V27.0423C39.0012 31.389 36.8287 35.4482 33.2119 37.8592L30.0004 40L26.7897 37.8593C23.1733 35.4482 21.0012 31.3894 21.0012 27.043V23.7207Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0012 26.5L28.0012 31.5M28.0012 26.5L33.0012 31.5M30.0004 40L33.2119 37.8592C36.8287 35.4482 39.0012 31.389 39.0012 27.0423V23.7208C39.0012 23.2903 38.7258 22.9082 38.3174 22.7721L30.3166 20.1054C30.1113 20.037 29.8894 20.037 29.6842 20.1054L21.685 22.7721C21.2766 22.9082 21.0012 23.2903 21.0012 23.7207V27.043C21.0012 31.3894 23.1733 35.4482 26.7897 37.8593L30.0004 40Z",
    stroke: "#FF8C1A",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUntilShipped);
export default __webpack_public_path__ + "static/media/UntilShipped.3f4554c1cc8015c1d2bb796bc9f63b19.svg";
export { ForwardRef as ReactComponent };